export const ADMIN_THEME = "#8b1634";

export const adminEditLabelStyle = {
  fontSize: 13,
  fontWeight: 600,
  color: "#374151",
  marginBottom: 6,
  display: "block",
};

export const adminEditInputStyle = {
  borderRadius: 8,
  border: "1px solid #e2e8f0",
  fontSize: 14,
  padding: "8px 12px",
};

export function parseSiteRegisterDate(value) {
  if (!value) return null;
  const s = String(value).trim();
  const slash = s.split("/");
  if (slash.length === 3) {
    const [dd, mm, yyyy] = slash;
    const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const dash = s.split("-");
  if (dash.length === 3) {
    if (dash[0].length === 4) {
      const d = new Date(Number(dash[0]), Number(dash[1]) - 1, Number(dash[2]));
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const [dd, mm, yyyy] = dash;
    const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

export function formatSiteRegisterDate(date) {
  if (!date) return "";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

export function formatIsoDate(date) {
  if (!date) return "";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${yyyy}-${mm}-${dd}`;
}

export const siteRegisterDatePickerProps = {
  dateFormat: "dd-MM-yyyy",
  className: "form-control",
  placeholderText: "dd-MM-yyyy",
  todayButton: "Today",
  calendarClassName: "site-register-theme-calendar",
  popperClassName: "site-register-datepicker-popper",
  popperPlacement: "bottom-start",
  popperProps: { strategy: "fixed" },
};

export const adminEditModalOverlayStyle = { display: "block", background: "rgba(0,0,0,0.45)" };

export const adminEditModalContentStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
  border: "none",
  borderRadius: 14,
  overflow: "hidden",
  boxShadow: "0 12px 40px rgba(0,0,0,0.18)",
};

export const adminEditModalHeaderStyle = {
  borderBottom: "none",
  padding: "16px 20px",
  background: `linear-gradient(135deg, ${ADMIN_THEME} 0%, #a01a3f 100%)`,
};

export const adminEditModalTitleStyle = { color: "#fff", fontWeight: 600, fontSize: 18, margin: 0 };

export const adminEditModalBodyStyle = { padding: "20px", background: "#fff", maxHeight: "75vh", overflowY: "auto" };

export const adminEditModalFooterStyle = { borderTop: "1px solid #eee", padding: "14px 20px", background: "#fafafa", gap: 10 };

export const adminEditCancelBtnStyle = {
  background: "#fff",
  color: "#374151",
  border: "1px solid #d1d5db",
  borderRadius: 8,
  padding: "8px 20px",
  fontWeight: 600,
  minWidth: 96,
};

export const adminEditSaveBtnStyle = {
  background: ADMIN_THEME,
  color: "#fff",
  fontWeight: 600,
  borderRadius: 8,
  padding: "8px 24px",
  border: "none",
};

export function adminEditSigBoxStyle(pointerEvents = "none") {
  return {
    width: "100%",
    border: `2px solid ${ADMIN_THEME}`,
    borderRadius: 12,
    background: "#f8f4f5",
    padding: "12px",
    textAlign: "center",
    minHeight: 120,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    pointerEvents,
  };
}
